"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const IntegrationAppContext = createContext(null);
IntegrationAppContext.displayName = "MembraneClientContext";
function useIntegrationApp() {
  return useContext(IntegrationAppContext);
}
const useMembrane = useIntegrationApp;

export { IntegrationAppContext, useIntegrationApp, useMembrane };
